/*
 ------------------------------------------------------------------
|  Copyright (c) 2015 Izenda, Inc.                                 |
|  ALL RIGHTS RESERVED                                             |
|                                                                  |
|  The entire contents of this file is protected by U.S. and       |
|  International Copyright Laws. Unauthorized reproduction,        |
|  reverse-engineering, and distribution of all or any portion of  |
|  the code contained in this file is strictly prohibited and may  |
|  result in severe civil and criminal penalties and will be       |
|  prosecuted to the maximum extent possible under the law.        |
|                                                                  |
|  RESTRICTIONS                                                    |
|                                                                  |
|  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES           |
|  ARE CONFIDENTIAL AND PROPRIETARY TRADE                          |
|  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS              |
|  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET    |
|  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.                 |
|                                                                  |
|  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED      |
|  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE        |
|  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE       |
|  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT  |
|  AND PERMISSION FROM IZENDA INC.                                 |
|                                                                  |
|  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  |
|  ADDITIONAL RESTRICTIONS.                                        |
 ------------------------------------------------------------------
*/

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import { Table, Column } from 'share/components/controls/DataGrid/Izenda.Table';
import { constant } from 'lodash/fp';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Button from 'share/components/controls/Izenda.Button';
import Input from 'share/components/controls/Izenda.Input';
import DropDown from 'share/components/controls/Izenda.DropDown';
import CONSTANT from 'logic/data/Izenda.SecurityRulesConstants';
import ControlBySharePermission from './Izenda.ControlBySharePermission';
import Select from 'share/components/controls/multiSelectBox/Izenda.Select';
import Validator from 'share/components/hoc/Izenda.Validator';

const ValidatorDropDown = Validator()(DropDown);
const ValidatorSelect = Validator()(Select);
const ValidatorInput = Validator()(Input);

const { RULES_TABLE_DEF: TABLE_DEF, ASSIGNED_TYPE, ACCESS_MODE_OPTIONS, ACCESSIBLE_VALUE_OPTIONS, CONSTRAINTS } = CONSTANT;

class SecurityRulesConfigureRules extends Component{
  constructor(props) {
    super(props);
  }

  addRule = () => {
    const { props: { rulesSet } } = this;
    rulesSet.addNewRule();
  }

  renderUserGroupCell = (rule) => {
    const onChange = (data) => {
      rule.updateUserGroup(data.value);
    };

    return (
      <ValidatorDropDown
        field="assignType"
        blankOption
        options={ASSIGNED_TYPE}
        value={rule.userGroup}
        valueField="value"
        labelField="label"
        validations={CONSTRAINTS.REQUIRED}
        onChange={onChange}
      />
    )
  }

  renderUserValueCell = (rule) => {
    const {props: {store}} = this;

    return (
      <ControlBySharePermission
        data={rule}
        store={store}
      />
    );
  }

  renderAccessibleVisibleValueCell = (rule) => {
    const onAddNew = (value) => {
      return rule.checkNewAccessibleValue(value);
    }

    const onChange = (values) => {
      rule.updateAccessibleValue(values);
    }

    return (
      <ValidatorSelect
        multi={true}
        options={ACCESSIBLE_VALUE_OPTIONS}
        labelKey={'label'}
        valueKey={'value'}
        scalable={false}
        value={rule.accessibleValuesInfo}
        onChange={onChange}
        onAddNew={onAddNew}
        field={'field'}
        inputMaxHeight={85}
        validations={CONSTRAINTS.REQUIRED}
        noResultsText={'Press Enter to add value'}
      />
    )
  }

  renderAccessModeCell = (rule) => {
    const onChange = (data) => {
      rule.updateAccessMode(data.value);
    };

    return (
      <ValidatorDropDown
        field="accessMode"
        blankOption
        options={ACCESS_MODE_OPTIONS}
        value={rule.accessMode}
        valueField="value"
        labelField="label"
        validations={CONSTRAINTS.REQUIRED}
        onChange={onChange}
      />
    )
  }

  renderActionCell = (rule) => {
    const { props: { rulesSet, localization } } = this;

    const cloneRule = () => {
      rulesSet.cloneRule(rule);
    };

    const deleteRule = () => {
      rulesSet.deleteRule(rule);
    };

    return (
      <div>
        <a onClick={cloneRule}><span title={localization.getText('SECURITY_RULES_SET_TOOLTIP_CLONE_RULE')} className="icon-copy" /></a>
        <span> </span>
        <a onClick={deleteRule}><span title={localization.getText('SECURITY_RULES_SET_TOOLTIP_DELETE_RULE')} className="icon-cancel" /></a>
      </div>
    );
  }

  onRuleMove = (oldPosititon, newPosititon, rule) => {
    const { props: { rulesSet } } = this;
    rulesSet.moveRule(oldPosititon, newPosititon, rule);
  }

  render(){
    const { props: { rulesSet, localization } } = this;

    const onChangeName = (e) => { 
      rulesSet.updateName(e.target.value); 
    }

    const onChangeDescription = (e) => {
      rulesSet.updateDescription(e.target.value);
    }

    const rules = rulesSet.activeRules;

    return (
      <div>
        <GridLayout className="u_paddingBottom">
          <GridLayout.Row>
            <GridLayout.Col cols={2} className="u_controlHeight">{localization.getText('SECURITY_RULES_SET_LABEL_NAME')}</GridLayout.Col>
            <GridLayout.Col cols={10}>
              <ValidatorInput validations={CONSTRAINTS.REQUIRED} className='form-control' value={rulesSet.name} onChange={onChangeName} />
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols={2} className="u_controlHeight">{localization.getText('SECURITY_RULES_SET_LABEL_DESCRIPTION')}</GridLayout.Col>
            <GridLayout.Col cols={10}>
              <Input className='form-control' value={rulesSet.description} onChange={onChangeDescription} />
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col className="u_textRight">
              <Button onClick={this.addRule} className="btn-report-default" label={localization.getText('SECURITY_RULES_SET_LABEL_ADD_RULE')} />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
        <Table
          dataSource={rules}
          isLoading={true}
          draggableTable={true}
          canDrag={constant(true)}
          canDrop={constant(true)}
          move={this.onRuleMove}>
            <Column {...TABLE_DEF['userGroup']} cell={this.renderUserGroupCell} />
            <Column {...TABLE_DEF['userValues']} cell={this.renderUserValueCell} />
            <Column {...TABLE_DEF['accessibleValues']} cell={this.renderAccessibleVisibleValueCell} />
            <Column {...TABLE_DEF['accessMode']} cell={this.renderAccessModeCell} />
            <Column {...TABLE_DEF['action']} cell={this.renderActionCell} />
        </Table>
      </div>
    );
  }
}

export default connect()(SecurityRulesConfigureRules);



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/SecurityRules/Izenda.SecurityRulesConfigureRules.jsx